import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { checkUserRoles } from '../../../lib/rolesAndPermissions'
import { formatDateTime } from '../../../lib/time'
import { useGetTNMItems } from './hooks'
// import { useGetTimeSheets } from './hooks'
import {
  Box,
  Checkbox,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
// import { useGetTimeSheets } from './hooks'
import { useEffect } from 'react'
// import { useGetTimeSheets } from './hooks'
import Excel from 'exceljs'
import moment from 'moment'
import { Refresh } from '@mui/icons-material'
import SnackBarContext from '../../../context/SnackBarContext'

export const ListTNMReports = (props: any) => {
  const { id, exportAsCSV} = props
  const queryKey = ['timematerialreport', id]
  const navigate = useNavigate()

  const toolBarConfig = {
    add: true,
    export: checkUserRoles(['vtadmin'], props.userRoles) ? true : false,
    upload: false,
  }

  const columns: any[] = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'baseReportNumber', headerName: 'Report Number', width: 130 },
    { field: 'createdAt', headerName: 'Date', flex: 1, width: 130 },
  ]

  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(25)
  const [checkedItems, setCheckedItems] = useState([])
  const { data, isFetching, error, refetch } = useGetTNMItems(
    queryKey[0],
    queryKey[1]
  )
  const {toggleSnackbar}=useContext(SnackBarContext)


  
  useEffect(() => {
    (async () => {
      if (exportAsCSV != null && data?.length > 0) {
        let workbook = new Excel.Workbook()
        const workbookColumns = columns.map(column => ({
          header: column.headerName,
          key: column.field,
          width: column.width || 20,
        }))
        let worksheet = workbook.addWorksheet('Sheet')
        worksheet.columns = workbookColumns

        data?.map((data: any) => {
          const obj: any = {
            ...columns
              .map(item => ({
                [item.field]: item.valueGetter
                  ? item.valueGetter({
                      row: data,
                      value: data[item.field],
                    })
                  : data[item.field] ?? '',
              }))
              .reduce((acc, item) => {
                acc = {
                  ...acc,
                  ...item,
                }
                return acc
              }, {}),
          }
          Object.keys(obj).forEach(key => {
            if (key.toLowerCase().includes('date') || key.toLowerCase().includes('created')) {
              obj[key] = formatDateTime(obj[key]);
            }
          })
          worksheet.addRow(obj)
        })
        const buffer = await workbook.csv.writeBuffer()
        const blob = new Blob([buffer], {
          type: 'text/csv',
        })
        const fileName = `T&M Reports ${moment().format('DD.MM.YY')}`
        const file = new File([blob], fileName, {
          type: 'text/csv',
        })

        const fileURL = URL.createObjectURL(file)

        const downloadLink = document.createElement('a')
        downloadLink.href = fileURL
        downloadLink.download = `${fileName}.${'csv'}`
        document.body.appendChild(downloadLink)
        downloadLink.click()
      }
      else if (exportAsCSV && data?.length == 0) {
        toggleSnackbar("No TNM reports available to export", "error")
      }
    })()
    refetch()
  }, [exportAsCSV, data, toggleSnackbar])

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ marginTop: 2, boxShadow: 'none' }}>
        <Table
          sx={{
            minWidth: 650,
            boxShadow: 'none',
          }}
          aria-label='simple table'>
          <TableHead sx={{}}>
            <TableRow
              sx={{
                '& th': {
                  backgroundColor: '#24212C',
                  padding: '7px',
                  color: 'white',
                  fontWeight: 400,
                  whiteSpace: 'nowrap',
                },
                '& th:first-child': {
                  borderRadius: '10px 0px 0px 10px',
                },
                '& th:last-child': {
                  borderRadius: '0px 10px 10px 0px',
                },
              }}>
              <TableCell>
                <Box
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <Checkbox
                    checked={(data || [])?.every(
                      (row: any) => checkedItems[row?._id] == true
                    )}
                    onChange={e => {
                      setCheckedItems(
                        (data || []).reduce((a: any, b: any) => {
                          a[b._id] = e.target.checked
                          return a
                        }, {})
                      )
                    }}
                    sx={{ color: 'white', fill: 'white' }}
                  />
                  {columns[0].headerName}
                </Box>
              </TableCell>
              {columns?.slice(1, columns.length).map(item => {
                return <TableCell>{item.headerName}</TableCell>
              })}
              <TableCell>ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              '& td': {
                backgroundColor: 'white',
                color: '#5F5C5F',
                fontWeight: 400,
                whiteSpace: 'nowrap',
                padding: '15px 0px',
                fontSize: 14,
              },
              '& td:first-child': {
                borderRadius: '10px 0px 0px 10px',
              },
              '& td:last-child': {
                borderRadius: '0px 10px 10px 0px',
              },
            }}>
            {data && data.length === 0 ? (
              <TableRow>
              <TableCell colSpan={12} style={{ textAlign: 'center' }}>
                No available data
              </TableCell>
            </TableRow>
            ) : (data)?.map((row: any, index: any) => (
              <TableRow
                key={row._id}
                sx={{
                  '& td, & th': {
                    border: 0,
                    background: index % 2 == 0 ? 'white' : '#F1EFF5',
                  },
                }}>
                <TableCell scope='row'>
                  <Box
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'left',
                    }}>
                    {checkedItems[row?._id] == true ? (
                      <Checkbox
                        checked={true}
                        onChange={e => {
                          setCheckedItems((prev: any) => {
                            return {
                              ...prev,
                              [row?._id]: e.target.checked,
                            }
                          })
                        }}
                        sx={{ color: '#D9D9D9', fill: 'white' }}
                      />
                    ) : (
                      <Checkbox
                        checked={false}
                        onChange={e => {
                          setCheckedItems((prev: any) => {
                            return {
                              ...prev,
                              [row?._id]: e.target.checked,
                            }
                          })
                        }}
                        sx={{ color: '#D9D9D9', fill: 'white' }}
                      />
                    )}

                    <Box
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '15ch',
                      }}>
                      {row[columns[0].field] ?? ''}
                    </Box>
                  </Box>
                </TableCell>
                {columns?.slice(1, columns.length).map(item => {
                  return<TableCell>
                  {item.field === 'createdAt' ? formatDateTime(row.createdAt) : row[item.field]}
                </TableCell>                
                })}
                <TableCell>
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 5,
                    }}>
                    <TimeSheetMenu data={row} />
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* <DataList
        columns={columns}
        user={null}
        queryKey={queryKey}
        useGetItems={useGetItems}
        toolBarItems={toolBarConfig}
        //useEditMutate={false}
        //useDeleteMutate={false}
        //customToolBar={false}
        //uploadPath={false}
        //uploadPath={uploadPath}
        addAction={() => navigate("daily-reports/new")}
        includeRowEdit={false}
        includeRowDelete={false}
        viewLink={"daily-reports"}
        checkboxSelection={false}
      /> */}
    </>
  )
}

const TimeSheetMenu = ({ data }: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const navigate = useNavigate()
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <Box
        sx={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          display: 'flex',
          paddingLeft: 3,
          cursor: 'pointer',
        }}>
        <IconButton
          sx={{ width: 35, height: 35 }}
          onClick={(event: any) => {
            setAnchorEl(event.currentTarget)
          }}>
          <svg
            width='16'
            height='6'
            viewBox='0 0 16 6'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M0 3.00065C0 3.57529 0.228273 4.12639 0.634602 4.53272C1.04093 4.93904 1.59203 5.16732 2.16667 5.16732C2.7413 5.16732 3.2924 4.93904 3.69873 4.53272C4.10506 4.12639 4.33333 3.57529 4.33333 3.00065C4.33333 2.42602 4.10506 1.87492 3.69873 1.46859C3.2924 1.06226 2.7413 0.833984 2.16667 0.833984C1.59203 0.833984 1.04093 1.06226 0.634602 1.46859C0.228273 1.87492 0 2.42602 0 3.00065Z'
              fill='#A5A2A5'
            />
            <path
              d='M5.8335 3.00065C5.8335 3.57529 6.06177 4.12639 6.4681 4.53272C6.87443 4.93904 7.42553 5.16732 8.00016 5.16732C8.5748 5.16732 9.1259 4.93904 9.53223 4.53272C9.93856 4.12639 10.1668 3.57529 10.1668 3.00065C10.1668 2.42602 9.93856 1.87492 9.53223 1.46859C9.1259 1.06226 8.5748 0.833984 8.00016 0.833984C7.42553 0.833984 6.87443 1.06226 6.4681 1.46859C6.06177 1.87492 5.8335 2.42602 5.8335 3.00065Z'
              fill='#A5A2A5'
            />
            <path
              d='M11.6665 3.00065C11.6665 3.57529 11.8948 4.12639 12.3011 4.53272C12.7074 4.93904 13.2585 5.16732 13.8332 5.16732C14.4078 5.16732 14.9589 4.93904 15.3652 4.53272C15.7716 4.12639 15.9998 3.57529 15.9998 3.00065C15.9998 2.42602 15.7716 1.87492 15.3652 1.46859C14.9589 1.06226 14.4078 0.833984 13.8332 0.833984C13.2585 0.833984 12.7074 1.06226 12.3011 1.46859C11.8948 1.87492 11.6665 2.42602 11.6665 3.00065Z'
              fill='#A5A2A5'
            />
          </svg>
        </IconButton>
      </Box>

      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}>
        <MenuItem
          onClick={() => {
            handleClose()
            navigate('time-material/' + data.id)
          }}>
          View
        </MenuItem>
      </Menu>
    </>
  )
}
